<template>
  <div id="app">
    <HeadComponent />
    <router-view></router-view>
    <FooterComponent />
  </div>
</template>

<script>
// @ is an alias to /src
import HeadComponent from '@/components/Header.vue';
import FooterComponent from '@/components/Footer.vue';

export default {
  components: {
    HeadComponent,
    FooterComponent,
  },
};
</script>

<style lang="css">
@import url("https://fonts.googleapis.com/css?family=Cardo:400,700|Josefin+Sans:300,400&display=swap");
@import url("./assets/ie.css");

body {
  margin: 0px;
  padding: 0px;
  color: #fff;
  font-family: "Josefin Sans", sans-serif;
  background-image: url("./assets/bluebg.png");
  background-repeat: repeat;
}
.bglines {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  max-width: 100%;
  z-index: 1;
}
.inner {
  position: relative;
  z-index: 2;
}
.home .inner,
.lista .inner {
  overflow: hidden;
}
.home,
.lista {
  position: relative;
  min-height: calc(100vh - 120px);
}
.head .inner,
.footer .inner,
.home .inner,
.lista .inner {
  max-width: 1350px;
  margin: 0 auto;
}
@media screen and (max-width: 767px) {

}
</style>
